<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div
    id="defaultId1 "
    class="margin-top10 margin-bottom10"
    v-loading="RiskLoding"
  >
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head-content">
        <div>
          <span class="operations-headspan">
            Distribution and Proportion of Import and Export Countries
          </span>
          <el-select
            class="map_select"
            v-model="Importyear"
            placeholder="Please Select"
            @change="getData"
          >
            <el-option
              v-for="item in Yearoptions"
              :key="item.year"
              :disabled="!item.hasData"
              :label="item.year"
              :value="item.year"
            >
            </el-option>
          </el-select>
        </div>

        <div class="perations-content-left">
          <span
            :class="
              activeIEports == '1'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            @click="ceckIEports('1')"
            >Imports</span
          >
          <span
            @click="ceckIEports('2')"
            :class="
              activeIEports == '2'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            >Exports</span
          >
        </div>
      </h2>

      <div class="operations-box">
        <div ref="SupplyChainEchart" style="width: 100%; height: 642px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  tradeTrends,
  geCountryDistributionYears,
  geCountryDistribution,
} from "@/api/companyApi.js";
export default {
  name: "",
  // props: {},
  components: {},
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },

      Importyear: "",
      Yearoptions: [],

      activeIEports: "1",
      importTrendListEcharts: [],
      allData: null,
      sourceData: [],
      diskData: [],

      reLoginVis: false,
      RiskLoding: false,
    };
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: false,
    });
    this.getselectHasDataYearsWithImportOrExport();
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getData();
    },
    getselectHasDataYearsWithImportOrExport() {
      geCountryDistributionYears({
        type: this.activeIEports,
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.Yearoptions = res.data;
          this.Importyear = res.data[0].year;
          this.getData();
        } else {
          this.Yearoptions = [];
        }
      });
    },
    getData() {
      this.RiskLoding = true;
      geCountryDistribution({
        type: this.activeIEports,
        countryCode: this.$route.query.id3a,
        impYear: this.Importyear,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.diskData = res.data;
          this.suppleEchart();
        } else {
          this.RiskLoding = false;
        }
      });
    },
    suppleEchart() {
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      let that = this;
      const formatUtil = this.$echarts.format;
      const option = {
        tooltip: {
          formatter: function (info) {
            var value = info.value;
            var treePathInfo = info.treePathInfo;
            var treePath = [];
            for (var i = 1; i < treePathInfo.length; i++) {
              treePath.push(treePathInfo[i].name);
            }
            return [
              '<div class="tooltip-title">' +
                formatUtil.encodeHTML(treePath.join("/")) +
                "</div>",
              "transaction volume: USD " + formatUtil.addCommas(value),
            ].join("");
          },
        },
        series: [
          {
            name: "transaction volume",
            type: "treemap",
            visibleMin: 0,
            label: {
              show: true,
              formatter: "{b}",
            },
            //去除底部路径
            breadcrumb: {
              show: false,
            },
            itemStyle: {
              borderColor: "#fff",
            },
            levels: that.getLevelOption(),
            data: that.diskData,
          },
        ],
      };

      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
    getLevelOption() {
      return [
        {
          itemStyle: {
            borderWidth: 0,
            gapWidth: 5,
          },
        },
        {
          itemStyle: {
            gapWidth: 1,
          },
        },
        {
          colorSaturation: [0.35, 0.5],
          itemStyle: {
            gapWidth: 1,
            borderColorSaturation: 0.6,
          },
        },
      ];
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-head {
  display: flex;
  justify-content: space-between;
}

.operations-headspan {
  margin-right: 26px;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.table-content-color {
  color: #009ea7;
}

.perations-button-active {
  background: #ffffff !important;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.2);
  border-radius: 1.5rem;
  color: #009ea7 !important;
  cursor: pointer;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
.map_select {
  width: 200px;
}
.font26 {
  font-size: 26px !important;
}
@media screen and (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .map_select {
    width: 150px;
  }
  .operations-headspan {
    margin-right: 20px;
  }
  .font26 {
    font-size: 20px !important;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .map_select {
    width: 130px;
    margin-left: 20px;
  }
  .operations-headspan {
    margin-right: 18px;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
